import { defineStore, acceptHMRUpdate } from 'pinia'
import { setToken } from '@/utils/auth'
import { USER_INFO } from '@/utils/constance'

import * as APIS from '@/api'

const apis = Object.values(APIS)

export const useUserStore = defineStore({
  id: 'user',
  state: () => ({
    token: '',
    userInfo: {},
    headerFlag: true
  }),
  actions: {
    setToken (token) {
      this.token = token
      setToken(token)
      // 重置header token
      apis.forEach((ins) => {
        ins.defaults.headers.common.Authorization = `Bearer ${token}`
      })
    },
    setUserInfo (info) {
      this.userInfo = info
    },
    deleteUserInfo () {
      this.userInfo = {}
    },
    setHeaderFlag (info) {
      this.headerFlag = info
    }
  },
  // 本地存储
  persist: {
    key: USER_INFO
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot))
}
